// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__Xprdx","love":"Footer_love__Kxih0"};